module.exports = __webpack_public_path__ + "static/media/Poppins-Regular.84ead272.woff2";